import { Horizontal } from "gls/lib";
import React from "react";
import { classes, style } from "typestyle";
import { checkboxStyle } from "./checkBoxStyles";
import { ComponentSchema } from "components/Renderer/Renderer";

export type CheckBoxProps = {
  checked: boolean;
  value: string | number;
  label?: string;
  name: string;
  ariaLabel?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  containerClassName?: string;
  verticalAlign?: "bottom" | "center" | "top" | "stretch" | "baseline" | undefined;
  dataTestId?: string;
  id?: string;
};

export const CheckBox = ({
  value,
  checked,
  label,
  onChange,
  name,
  disabled,
  containerClassName,
  verticalAlign,
  id = `checklist-${name}-${label}`
}: CheckBoxProps) => {

  return (
    <Horizontal
      spacing={12}
      className={classes(containerClassName, checkboxStyle(disabled))}
      verticalAlign={verticalAlign || "center"}
    >
      <label
        className={wrapperStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <input
          id={id}
          type="checkbox"
          checked={checked}
          value={value}
          name={name}
          onChange={onChange}
          onClick={(e) => e.stopPropagation()}
          disabled={disabled}
        />
      </label>
      {label && <label htmlFor={id}>{label}</label>}
    </Horizontal>
  );
};

export const CheckBoxOptions: ComponentSchema = {
  label: "CheckBox",
  type: "CheckBox",
  icon: "CheckBoxIcon",
  propsSchema: [
    {
      id: "label",
      type: "Input",
      props: {
        label: "Label",
      },
    },
    {
      id: "ariaLabel",
      type: "Input",
      props: {
        label: "Aria Label",
      },
    },
  ],
};

export const CheckBoxDefaultProps = {
  label: "CheckBox",
  defaultValue: false,
};

const wrapperStyle = style({
  lineHeight: 0,
  cursor: "pointer",
});
